import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openRequestCallbackPopup } from '../../actions/requestCallback';
import { trackCallbackPopupOpen } from '../../analytics/trackCallback';
import { CallbackButton } from '../../components/CallbackButton';
import { getGaLabel } from '../../selectors/analytics';
import { getAgentForCallback } from '../../selectors/newbuilding/agent';
import { TRequestCallbackOpener } from '../../types/requestCallback';

export interface ICallMeBackContainerProps {
  placeType: TRequestCallbackOpener;
}

export function CallMeBackContainer({ placeType }: ICallMeBackContainerProps) {
  const agent = useSelector(getAgentForCallback);
  const gaLabel = useSelector(getGaLabel);
  const dispatch = useDispatch();

  const handleCallBackPopupOpen = React.useCallback(() => {
    trackCallbackPopupOpen(gaLabel, placeType);

    dispatch(openRequestCallbackPopup(placeType));
  }, [dispatch, gaLabel, placeType]);

  if (!agent) {
    return null;
  }

  return <CallbackButton onClick={handleCallBackPopupOpen} />;
}
